import React from 'react';
import { connect } from 'react-redux';

const ContainerFluid = ({ children, alert }) => {
  return <div className="container-fluid mt-4">
    {alert.message &&
      <div className={`alert ${alert.type}`}>{alert.message}</div>
    }

    {children}
  </div>
}

function mapStateToProps(state) {
  return {
    alert: state.alert
  };
}

export default connect(mapStateToProps)(ContainerFluid);